import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { InterCopmonentDataCarrierService } from '../../../../../services/inter-copmonent-data-carrier-service/inter-copmonent-data-carrier.service';
import { PageHeadingService } from '../../../../../services/page-heading-service/page-heading.service';
import { MenuUtils } from '../../../../../utils/menu-utils';
import { Homework } from '../../models/homework';
import { HomeworksService } from '../../services/homeworks.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-homeworks',
  templateUrl: './homeworks.component.html',
  styleUrls: ['./homeworks.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HomeworksComponent extends ComponentBase implements OnInit {

  constructor(private homeworksService: HomeworksService
    , private pageHeadingService: PageHeadingService
    , private interComponentService: InterCopmonentDataCarrierService) {
    super();
  }

  homeworks: Array<Homework> = [];
  groupedHomeworks: any;
  todaysdate: string = new Date().toISOString().split('T')[0];
  tommorowsdate: string = new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toISOString().split('T')[0];
  showCalendar: boolean = false;
  showOptions: boolean = false;
  showToday: boolean = true;
  selectedDate: Date;
  optionSelected: string = 'Upcoming';
  heading: string;
  loading: boolean = true;
  isOnline: boolean = true;
  public config: PerfectScrollbarConfigInterface = {};

  ngOnInit() {
    this.pageHeadingService.menuOnChange(MenuUtils.getMenuItem("Assignments"));
    let dateFromCalendar = this.interComponentService.retrieve("hwDate")
    if (dateFromCalendar) {
      this.dateSeleted(dateFromCalendar);
      this.interComponentService.delete("hwDate");
    } else {
      this.getUpcoming();
    }
  }

  getUpcoming() {
    let subscription = this.homeworksService.getHomeworks()
      .subscribe(res => {
        this.loading = false;
        this.showToday = true;
        this.homeworks = res;
        this.groupedHomeworks = this.groupByDate(this.homeworks).filter(o => o.key.split('T')[0] != this.todaysdate && o.key.split('T')[0] != this.tommorowsdate);
        this.heading = "Upcoming";
      })
    this.addSubscription(subscription);

  }

  filterHomeworksUsingDate(date: string) {
    return this.homeworks.filter(o => o.target_date.split('T')[0] == date);
  }

  groupByDate(array: Array<Homework>) {
    var groups = {};
    array.forEach(function (o) {
      var group = o.target_date;
      groups[group] = groups[group] || [];
      groups[group].push(o);
    });
    return Object.keys(groups).map(key => ({ key, value: groups[key] })).sort((a, b) => (a.key > b.key ? 1 : -1));
  }

  selectDateClicked() {
    this.showCalendar = !this.showCalendar;
  }

  clickedOutsideSelectDate() {
    if (this.showCalendar) {
      this.showCalendar = !this.showCalendar;
    }
  }

  dateSeleted(day: Date) {
    this.showCalendar = !this.showCalendar;
    this.selectedDate = day;
    let subscription = this.homeworksService.GetHomeworksByDateRange(day, day)
      .subscribe(res => {
        this.heading = '';
        this.showToday = false;
        this.homeworks = res;
        this.groupedHomeworks = this.groupByDate(this.homeworks)
      });
    this.addSubscription(subscription);
  }

  onOptionsSelected(event) {
    this.showOptions = !this.showOptions;
    let option = event.target.innerText;
    if (option != 'Upcoming') {
      var fromDate = new Date();
      var toDate = new Date();
      if (option == 'Last one month') {
        fromDate.setMonth(fromDate.getMonth() - 1);
      }
      else if (option == 'Last three months') {
        fromDate.setMonth(fromDate.getMonth() - 3);
      }
      else if (option == 'Last six months') {
        fromDate.setMonth(fromDate.getMonth() - 6);
      }
      else {
        fromDate = new Date("1 1, 0100");
        toDate = new Date("12 12, 9999");
      }
      let subscription = this.homeworksService.GetHomeworksByDateRange(fromDate, toDate)
        .subscribe(res => {
          this.showToday = false;
          this.homeworks = res;
          this.groupedHomeworks = this.groupByDate(this.homeworks).filter(o => o.key.split('T')[0] != this.todaysdate);
          this.heading = option;
        });
      this.addSubscription(subscription);
    }
    else if (option == 'Upcoming') {
      this.getUpcoming();
    }
  }

  moreClicked() {
    this.showOptions = !this.showOptions;
  }
  clickedOutsideMore() {
    if (this.showOptions) {
      this.showOptions = !this.showOptions;
    }
  }

}
